import React from 'react'
import SearchBarHotel from './SearchBarHotel'
import PopularDestination from './PopularDestination'
import PopularInternationalDestination from './PopularInternationalDestination'
import Seo from '../../helmet/Helmet'

function HotelsHome() {
    return (
        <>
            <Seo
                title="SuperbWorldTrip: Hotel Booking in Affordable Price with Upto 10% Discount"
                description="SuperbWorldTrip offers Lowest hotel booking with upto 10% discount. Find budget & premium hotels worldwide with easy booking & safe payment."
                link="/hotels"
                keywords="cheap hotels, budget hotels, hotel booking offers, lowest hotel deals, best hotel discounts, affordable stays, hotel comparison, last-minute hotel booking, international hotels, hotel reservation online, discounted hotel prices, book hotels online, best prices on hotels, hotel deals near me, luxury hotels at low price, online hotel booking, hotel deals today"
                largeTwitterCard={true}
                addPostfixTitle={false}
                noIndex={true}
            />
            <SearchBarHotel />
            <PopularDestination />
            <PopularInternationalDestination />
        </>
    )
}

export default HotelsHome